<template>
  <div ref="containerRef"></div>
</template>
<script>
import { ref, onMounted } from 'vue'
import lottie from 'lottie-web'

export default {
  props: {
    src: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const containerRef = ref(null)
    const animation = ref(null)

    onMounted(() => {
      if (!containerRef.value) return

      animation.value = lottie.loadAnimation({
        container: containerRef.value,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: props.src,
        rendererSettings: {
          preserveAspectRatio: 'xMidYMid meet',
        },
      })
    })

    return {
      containerRef,
    }
  },
}
</script>
